import { render, staticRenderFns } from "./WheelsStepwiseIndicator.vue?vue&type=template&id=dbb1a088&scoped=true"
import script from "./WheelsStepwiseIndicator.vue?vue&type=script&setup=true&lang=ts"
export * from "./WheelsStepwiseIndicator.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./WheelsStepwiseIndicator.vue?vue&type=style&index=0&id=dbb1a088&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbb1a088",
  null
  
)

export default component.exports